<!------------ START TEMPLATE ------------>
<template>
  <vs-popup
    class="holamundo"
    :title="title"
    :active.sync="exibeModal"
    @close="closeModal"
  >
    <table class="table table-bordered">
      <tr v-for="item in modalSelecionado" :key="item.id">
        <th class="uppercase">{{ item.coluna }}</th>
        <td>
          <div v-if="item.coluna == 'senha'">******</div>
          <div v-else-if="typeof item[item.coluna] == 'object'">
            <div v-for="itemaux in item[item.coluna]" :key="itemaux.id">
              <ul>
                <li v-for="itemCol in Object.keys(itemaux)" :key="itemCol.id">
                  <div v-if="itemCol.indexOf('id') != 0">
                    <b>{{ itemCol }}:&nbsp;</b>
                    <span v-if="itemCol == 'valor' || itemCol == 'preco'">{{
                      itemaux[itemCol] | currency
                    }}</span>
                    <span v-else>{{ itemaux[itemCol] }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-else-if="item.coluna == 'Valor' || item.coluna == 'ValorPromocao'"
          >
            {{ item[item.coluna] | currency }}
          </div>
          <div v-else-if="item.coluna.indexOf('data') == 0">
            {{ objConverterData.converteISOToDate(item[item.coluna]) }}
          </div>
          <div v-else-if="item.coluna == 'logo' || item.coluna == 'foto'">
            <img
              v-if="item[item.coluna]"
              :src="showPicture(item[item.coluna])"
              width="150px"
            />
            <img
              v-else
              width="150px"
              src="https://simplesbucket.s3.amazonaws.com/reusar/sem-foto.jpg"
            />
          </div>
          <div v-else>{{ formataTexto(item[item.coluna]) }}</div>
        </td>
      </tr>
    </table>
  </vs-popup>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import moment from 'moment';
import dateConversion from '../utils/dateConversion';

export default {
  props: ['modalSelecionado', 'popupActive', 'title'],
  watch: {
    popupActive: function (newValue) {
      this.exibeModal = newValue;
    },
  },
  data() {
    return {
      exibeModal: false,
      objConverterData: dateConversion,
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    showPicture(foto) {
      return `https://bboneapp.s3.amazonaws.com/imgsADM/${foto}`;
    },
    formataData(data) {
      // formats data received from API
      var formattedData = moment(data).format('DD/MM/YYYY');
      return formattedData;
    },
    formataTexto(texto) {
      if (Number.isInteger(texto)) return texto;
      if (texto == true) return 'sim';
      if (texto == false) return 'não';
      return texto;
    },
  },
};
</script>
<!------------ END SCRIPT ------------>
